import { FC, PropsWithChildren } from 'react';
import { GlobalStyles, ThemeProvider as MuiThemeProvider } from '@mui/material';
import { muiTheme } from '@/theme/theme';
import { globalStyles } from '@/theme/ThemeProvider/globalStyles';

export const ThemeProvider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <MuiThemeProvider theme={muiTheme}>
      <GlobalStyles styles={globalStyles} />
      {children}
    </MuiThemeProvider>
  );
};
